/**
 * Asset resolution against the app's public BASE.
 *
 * Do NOT use `document.baseURI` alone: in an SPA with nested routes
 * (e.g. `/instrument/piano`) the baseURI is the route itself, so a
 * relative asset like `audio/piano/C4.ogg` would resolve to
 * `/instrument/audio/piano/C4.ogg`; the server's SPA fallback returns
 * index.html with 200 and the audio decode blows up (EncodingError).
 */

/** `import.meta.env` hand-typed: game-core does not depend on vite/client. */
interface BundlerEnv {
  env?: { BASE_URL?: string };
}

/** The app's public base: Vite's BASE_URL if the bundler injects it; root otherwise. */
export function appBaseUrl(): string {
  const { env } = import.meta as ImportMeta & BundlerEnv;
  return new URL(env?.BASE_URL ?? "/", document.baseURI).toString();
}

/** Resolves an asset path (no leading `/`) against the app base. */
export function resolveAssetUrl(path: string): string {
  return new URL(path, appBaseUrl()).toString();
}
